import React from 'react';
import DesktopSVG from '../../images/svg/ui.svg';
import './hero.scss';

function Hero() {
  return (
    <div className="hero">
      <div className="container hero__inner">
        <div className="hero__content">
          <h1 className="hero__title">
            Add SVG images to <b>Ember</b>  the easiest way possible.
          </h1>

          <p className="hero__text">
            Search and preview all your project icons in one place.
            Reduce the size of your assets. Empower your team.
          </p>

          <ul className="hero__benefits-list">
            <li className="hero__benefits-item">
              Modern, visual workflow
            </li>
            <li className="hero__benefits-item">
              Automatic optimization
            </li>
          </ul>

          <section className="hero__cta">
            <a
              className="button"
              href="https://svgjar-demo.web.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Demo
            </a>

            <a
              className="button button--secondary"
              href="https://github.com/voltidev/ember-svg-jar#-getting-started"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get started
            </a>
          </section>
        </div>

        <figure className="hero__figure">
          <div className="hero__img">
            <DesktopSVG />
          </div>
        </figure>
      </div>
    </div>
  );
}

export default Hero;
